export default __webpack_public_path__ + "static/media/cTocIcon.83057e6d.png";